import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectSignedIn } from "reducers/auth";
import { AccessElement, Scopes, useLoadScopes } from "helpers/auth";
import { Link, Location } from "react-router-dom";
import dropdownArrow from "assets/Icon_Form_Arrow.png";
import { Transition } from "react-transition-group";
import platformUsersIcon from "assets/Icon_Menu_11.png";
import companiesIcon from "assets/Icon_Menu_13.png";
import contactsIcon from "assets/Icon_Menu_11.png";
import projectSetupIcon from "assets/Icon_Menu_15.png";
import rolesIcon from "assets/Icon_Menu_12.png";
import sitesIcon from "assets/Icon_Menu_03.png";
import assetsIcon from "assets/Icon_Menu_04.png";
import documentsIcon from "assets/Icon_Menu_07.png";
import programmesIcon from "assets/Icon_Menu_14.png";
import dashboardsIcon from "assets/Icon_Menu_01.png";
import gatewaysIcon from "assets/Icon_Menu_17.png";
import workflowConfigurationIcon from "assets/Icon_Menu_16.png";
import portalConfigurationIcon from "assets/Icon_Menu_26.png";
import cataloguesIcon from "assets/Icon_Menu_25.png";
import surveysIcon from "assets/Icon_Menu_05.png";
import workflowsIcon from "assets/Icon_Menu_06.png";
import invoicesIcon from "assets/Icon_Menu_20.png";
import customFields from "assets/portal_Custom fields.png";
import customTypes from "assets/portal_Custom types.png";
import catalogueSubGroups from "assets/portal_cataglogue_sub_groups.png";
import holidays from "assets/portal_holidays.png";
import reasonCodes from "assets/portal_Reason_code.png";
import ExchangeRate from "assets/portal_Exchange_rates.png";
import catalogueCatagories from "assets/portal_catalogue_ catagories.png";
import projectStatus from "assets/portal_Project_status.png";
import siteStatus from "assets/portal_site_status.png";
import surveyors from "assets/portal_Surveyors.png";
import emailtemplates from "assets/Icon_Menu_22.png";
import homeIcon from "assets/home.png";
import paymentOptions from "assets/portal_payment_options.png";
import currencies from "assets/portal_currencies.png";
import userPools from "assets/portal_user_pools.png";
import loggingIcon from "assets/logging.png";
import apiIcon from "assets/api.png";
import pushIcon from "assets/greendoor_push.png";
import kpisIcon from "assets/Icon_Menu_09.png";
import communicationTypeIcon from "assets/Icon_Menu_22.png";
import communicationCategoriesIcon from "assets/Icon_Menu_22.png";
import snaggingCategoriesIcon from "assets/Icon_Menu_22.png";
import supplierFeedbackIcon from "assets/Icon_Menu_22.png";
import ncrCategoryIcon from "assets/Icon_Menu_22.png";
import countriesIcon from "assets/Icon_Menu_18.png";
import { MdShoppingBasket } from "react-icons/md";
import { customUseOnClickOutside } from "components/helpers/CustomFieldRenderers/SearchListFieldRenderer/SearchListRenderer";

const USE_NESTED_NAVIGATION_ITEMS = true;

const NESTED_ITEM_IMAGES: any = {
  customfields: customFields,
  assetcustomfields: assetsIcon,
  projectcustomfields: projectSetupIcon,
  sitescustomfields: sitesIcon,
  catalogueitemcustomfields: cataloguesIcon,
  customtypes: customTypes,
  holidays: holidays,
  reasoncodes: reasonCodes,
  cataloguesubgroups: catalogueSubGroups,
  exchangerates: ExchangeRate,
  cataloguecategories: catalogueCatagories,
  surveyors: surveyors,
  projectstatustypes: projectStatus,
  sitestatustypes: siteStatus,
  projecttypes: projectSetupIcon,
  contacttypes: contactsIcon,
  documenttypes: documentsIcon,
  programmetypes: programmesIcon,
  sitetypes: sitesIcon,
  roletypes: rolesIcon,
  invoicecategorytypes: invoicesIcon,
  cataloguegroups: cataloguesIcon,
  assetstatustypes: assetsIcon,
  surveytemplates: surveysIcon,
  emailtemplates: emailtemplates,
  paymentoptiontypes: paymentOptions,
  currencies: currencies,
  greendoorpush: pushIcon,
  greendoorapi: apiIcon,
  kpis: kpisIcon,
  communicationtypes: communicationTypeIcon,
  communicationcategories: communicationCategoriesIcon,
  snaggingcategories: snaggingCategoriesIcon,
  supplierfeedback: supplierFeedbackIcon,
  ncrcategory: ncrCategoryIcon,
  countries: countriesIcon,
};

const TOP_LEVEL_ITEM_IMAGES: any = {
  platformusers: platformUsersIcon,
  principleusers: platformUsersIcon,
  companies: companiesIcon,
  contacts: contactsIcon,
  projects: projectSetupIcon,
  roles: rolesIcon,
  sites: sitesIcon,
  assets: assetsIcon,
  documents: documentsIcon,
  programmes: programmesIcon,
  clientcompanies: companiesIcon,
  dashboards: dashboardsIcon,
  gateways: gatewaysIcon,
  workflowconfiguration: workflowConfigurationIcon,
  taskworkflowsyncmappings: workflowConfigurationIcon,
  catalogueitems: cataloguesIcon,
  portalconfiguration: portalConfigurationIcon,
  projectmanagement: projectSetupIcon,
  surveys: surveysIcon,
  workflows: workflowsIcon,
  invoices: invoicesIcon,
  shop: MdShoppingBasket,

  home: homeIcon,
  userpools: userPools,
  logging: loggingIcon,
};

const DEFAULT_GROUP_NAME = "DEFAULT";

type Props = {
  mobileNavOpen: boolean;
  closeMobileNav(): void;
  location: Location;
  // location: WindowLocation;
  hide?: boolean;
  shrinkNavMenu: boolean;
};

type AccessElementWithOrderNumber = AccessElement & {
  orderNumber: number;
};

const createOrderedAccessElements = (accessElements: Scopes) => {
  let groupedAccessElements: {
    [key: string]: AccessElementWithOrderNumber[];
  } = {};

  accessElements.forEach((item, idx) => {
    const groupLabel = item.groupLabel ?? "";

    if (groupLabel && item.elementType && item.elementType === "Navigation") {
      let tempGroupedAccessElements = { ...groupedAccessElements };

      tempGroupedAccessElements[groupLabel] =
        tempGroupedAccessElements[groupLabel] &&
        Array.isArray(tempGroupedAccessElements[groupLabel])
          ? [...tempGroupedAccessElements[groupLabel], { ...item, orderNumber: idx }]
          : [{ ...item, orderNumber: idx }];
      groupedAccessElements = tempGroupedAccessElements;
    }
  });

  let orderedAccessElements: {
    [key: string]: AccessElementWithOrderNumber[];
  } = {};

  if (groupedAccessElements.hasOwnProperty(DEFAULT_GROUP_NAME)) {
    orderedAccessElements[DEFAULT_GROUP_NAME] = groupedAccessElements[DEFAULT_GROUP_NAME];

    delete groupedAccessElements[DEFAULT_GROUP_NAME];
  }

  orderedAccessElements = {
    ...orderedAccessElements,
    ...groupedAccessElements,
  };

  let sortedOrderedAccessElements: {
    [key: string]: AccessElementWithOrderNumber[];
  } = { ...orderedAccessElements };

  Object.keys(orderedAccessElements).forEach((key) => {
    sortedOrderedAccessElements[key].sort((a, b) => a.orderNumber - b.orderNumber);
  });

  return sortedOrderedAccessElements;
};

const Navigation: React.FC<Props> = ({
  closeMobileNav,
  location,
  mobileNavOpen,
  hide,
  shrinkNavMenu,
}) => {
  const isSignedIn = useSelector(selectSignedIn);
  const accessElements = useLoadScopes();

  const orderedAccessElements = createOrderedAccessElements(accessElements);

  const pathname = location.pathname;

  const bind = customUseOnClickOutside(closeMobileNav, true);

  if (!isSignedIn || hide) return null;

  return (
    <Transition in={mobileNavOpen} timeout={0}>
      {(transitionState) => (
        <>
          <nav
            id="MainNavigation"
            data-testid="nav-root"
            className={`Navigation ${mobileNavOpen ? " Open" : ""} ${
              shrinkNavMenu ? "SmallNav" : ""
            } ${transitionState}`}
            {...bind}
          >
            <div className="Inner" data-testid="nav-inner">
              <div className="Block">
                {orderedAccessElements &&
                  Object.keys(orderedAccessElements).map((item, idx) => {
                    const value = orderedAccessElements[item];
                    return (
                      <ul
                        className={`NavigationGroup ${item}`}
                        data-testid="nav-group"
                        key={`navigation-group-${idx}`}
                      >
                        {item && item !== DEFAULT_GROUP_NAME && (
                          <div className="NavigationGroupTitle" data-testid="nav-group-title">
                            {item}
                          </div>
                        )}

                        {value.map((e, idx) => {
                          if (
                            e &&
                            e.hasOwnProperty("elementType") &&
                            e.elementType === "Navigation" // Filter Out Header Navigation types
                          ) {
                            return (
                              <TopLevelItem
                                accessElement={e}
                                pathName={pathname}
                                closeMobileNav={closeMobileNav}
                                key={`top-level-item-${idx}-${e.displayName}`}
                              />
                            );
                          } else {
                            return null;
                          }
                        })}
                      </ul>
                    );
                  })}
              </div>
            </div>
          </nav>

          <div
            data-testid="nav-overlay"
            className={`MainNavigationOverlay ${mobileNavOpen ? "Open" : ""} ${transitionState}`}
          ></div>
        </>
      )}
    </Transition>
  );
};

export default Navigation;

const getChildElementsNestedItemPathNames = (
  childElements: AccessElement[],
  nestedPathNames: string[]
) => {
  let tempNestedPathNames = [...nestedPathNames];

  childElements.forEach((item) => {
    if (item.path) {
      tempNestedPathNames = [...tempNestedPathNames, item.path];
    }
    if (item.childElements) {
      const updatedTempNestedPathNames = getNestedItemsPathNames(item);

      tempNestedPathNames = [...updatedTempNestedPathNames, ...tempNestedPathNames];
    }
  });

  return tempNestedPathNames;
};

const getNestedItemsPathNames = (accessElement: AccessElement) => {
  let finalNestedPathNames: string[] = [];
  if (
    accessElement.childElements &&
    Array.isArray(accessElement.childElements) &&
    accessElement.childElements.length > 0
  ) {
    finalNestedPathNames = getChildElementsNestedItemPathNames(
      accessElement.childElements,
      finalNestedPathNames
    );
  }

  return finalNestedPathNames;
};

const pathContainsPath = (currentPathName: string, itemPathName: string | null) => {
  return itemPathName ? `${currentPathName} `.includes(`/${itemPathName} `) : false;
};

const pathContainsExternalLink = (currentPathName: string) => {
  return currentPathName.includes("http");
};

const checkChildElementsAreNavigationElements = (childElements: Scopes) => {
  let navigationElements: boolean = false;

  childElements.forEach((item) => {
    if (
      item.childElements &&
      Array.isArray(childElements) &&
      childElements.length > 0 &&
      childElements[0] &&
      typeof childElements[0] === "object" &&
      childElements[0].hasOwnProperty("childElements") &&
      childElements[0].childElements &&
      Array.isArray(childElements[0].childElements) &&
      childElements[0].childElements.length > 0
    ) {
      navigationElements = true;
    }
  });

  return navigationElements;
};

const TopLevelItem: React.FC<{
  accessElement: AccessElement;
  pathName: string;
  closeMobileNav(): void;
}> = ({ accessElement, pathName, closeMobileNav }) => {
  const [showNestedElements, setShowNestedElements] = useState<boolean>(false);
  const [active, setActive] = useState<boolean>(false);
  const [nestedItemActive, setNestedItemActive] = useState<boolean>(false);
  const [hasNestedElements, setHasNestedElements] = useState<boolean>(false);
  const [isExternalLink, setIsExternalLink] = useState<boolean>(false);

  useEffect(() => {
    const tempHasNestedElements =
      accessElement.childElements &&
      Array.isArray(accessElement.childElements) &&
      accessElement.childElements.length > 0 &&
      checkChildElementsAreNavigationElements(accessElement.childElements)
        ? true
        : false;

    setHasNestedElements(tempHasNestedElements);

    const nestedElementsPaths = getNestedItemsPathNames(accessElement);

    let nestedItemInPathNameActive = false;

    nestedElementsPaths.forEach((item) => {
      if (pathContainsPath(pathName, item)) {
        nestedItemInPathNameActive = true;
      }
    });

    setNestedItemActive(nestedItemInPathNameActive);

    const tempActive = pathContainsPath(pathName, accessElement.path);
    setActive(tempActive);

    if (!tempActive && !nestedItemInPathNameActive) {
      setShowNestedElements(false);
    }

    setIsExternalLink(pathContainsExternalLink(accessElement.path ?? ""));
  }, [pathName, accessElement]);

  const handleClick = () => {
    setShowNestedElements(!showNestedElements);
  };

  return (
    <li
      data-testid="nav-top-item"
      className={`TopLevelItemContainer ${active ? "Active" : ""} ${
        nestedItemActive ? "NestedItemActive" : ""
      } ${hasNestedElements && showNestedElements ? "TopLevelItemOpen" : ""}`}
    >
      <div
        className={`TopLevelItem  ${hasNestedElements && showNestedElements ? "Open" : ""}`}
        onClick={handleClick}
      >
        {TOP_LEVEL_ITEM_IMAGES.hasOwnProperty(accessElement.path) ? (
          <div className="ImageContainer">
            {typeof TOP_LEVEL_ITEM_IMAGES[
              accessElement.path as keyof typeof TOP_LEVEL_ITEM_IMAGES
            ] === "string" ? (
              <img
                src={
                  TOP_LEVEL_ITEM_IMAGES[accessElement.path as keyof typeof TOP_LEVEL_ITEM_IMAGES]
                }
                alt="navigation item"
              />
            ) : (
              (() => {
                const IconComponent =
                  TOP_LEVEL_ITEM_IMAGES[accessElement.path as keyof typeof TOP_LEVEL_ITEM_IMAGES];
                return <IconComponent size={24} />;
              })()
            )}
          </div>
        ) : (
          <div className="ImageContainer">
            <div className="PlaceholderImage">
              <div className="Text">
                {accessElement &&
                  accessElement.displayName &&
                  typeof accessElement.displayName == "string" &&
                  accessElement.displayName.length > 0 &&
                  accessElement.displayName.charAt(0)}
              </div>
            </div>
          </div>
        )}

        {active && <div className="ActiveMarker" data-testid="nav-active-marker"></div>}

        {USE_NESTED_NAVIGATION_ITEMS && hasNestedElements && (
          <img
            src={dropdownArrow}
            alt="dropdown"
            className={`DropdownIcon ${showNestedElements ? "Open" : ""}`}
          />
        )}

        {hasNestedElements ? (
          <div className="NestedItemText">{accessElement.displayName}</div>
        ) : !accessElement.path ? (
          <div className="Text">{accessElement.displayName}</div>
        ) : isExternalLink ? (
          <a href={accessElement.path} target="_blank" rel="noreferrer">
            <div className="Text">{accessElement.displayName}</div>
          </a>
        ) : (
          <Link to={accessElement.path} onClick={closeMobileNav}>
            <div className="Text">{accessElement.displayName}</div>
          </Link>
        )}
      </div>

      {USE_NESTED_NAVIGATION_ITEMS && showNestedElements && hasNestedElements && (
        <NestedElements
          accessElement={accessElement}
          pathName={pathName}
          closeMobileNav={closeMobileNav}
          showNestedElements={showNestedElements}
        />
      )}
    </li>
  );
};

type NestElementsProps = {
  accessElement: AccessElement;
  pathName: string;
  closeMobileNav(): void;
  showNestedElements: boolean;
};

const NestedElements: React.FC<NestElementsProps> = ({
  accessElement,
  pathName,
  closeMobileNav,
  showNestedElements,
}) => {
  return (
    <ul
      className={`NestedItemsContainer ${showNestedElements ? "Open" : ""}`}
      data-testid="nav-nested-container"
    >
      {accessElement.childElements &&
        Array.isArray(accessElement.childElements) &&
        accessElement.childElements.length > 0 &&
        accessElement.childElements.map((nestedItem: any, idx: number) => {
          return (
            <NestedElement
              nestedItem={nestedItem}
              pathName={pathName}
              closeMobileNav={closeMobileNav}
              key={`$nested-element-${idx}`}
            />
          );
        })}
    </ul>
  );
};

type NestedElementProps = {
  nestedItem: AccessElement;
  pathName: string;
  closeMobileNav: () => void;
};

const NestedElement: React.FC<NestedElementProps> = ({ nestedItem, pathName, closeMobileNav }) => {
  const [showNestedElements, setShowNestedElements] = useState<boolean>(false);
  const [active, setActive] = useState<boolean>(false);
  const [nestedItemActive, setNestedItemActive] = useState<boolean>(false);
  const [hasNestedElements, setHasNestedElements] = useState<boolean>(false);
  const [isExternalLink, setIsExternalLink] = useState<boolean>(false);

  const handleClick = (item: any) => {
    setShowNestedElements(!showNestedElements);
  };

  useEffect(() => {
    const tempHasNestedElements =
      nestedItem.childElements &&
      Array.isArray(nestedItem.childElements) &&
      nestedItem.childElements.length > 0 &&
      checkChildElementsAreNavigationElements(nestedItem.childElements)
        ? true
        : false;

    setHasNestedElements(tempHasNestedElements);

    const nestedElementsPaths = getNestedItemsPathNames(nestedItem);

    let nestedItemInPathNameActive = false;

    nestedElementsPaths.forEach((item) => {
      if (pathContainsPath(pathName, item)) {
        nestedItemInPathNameActive = true;
      }
    });

    setNestedItemActive(nestedItemInPathNameActive);

    const tempActive = pathContainsPath(pathName, nestedItem.path);
    setActive(tempActive);

    if (!tempActive && !nestedItemInPathNameActive) {
      setShowNestedElements(false);
    }

    setIsExternalLink(pathContainsExternalLink(nestedItem.path ?? ""));
  }, [pathName, nestedItem]);

  return (
    <div className="NestedItemContainer">
      <li
        className={`NestedItem ${active ? "Active" : "NotActive"} ${
          nestedItemActive ? "NestedItemActive" : ""
        } ${showNestedElements ? "Open" : ""}`}
        onClick={() => handleClick(nestedItem)}
      >
        {NESTED_ITEM_IMAGES.hasOwnProperty(nestedItem.path) ? (
          <div className="ImageContainer">
            {typeof NESTED_ITEM_IMAGES[nestedItem.path as keyof typeof NESTED_ITEM_IMAGES] ===
            "string" ? (
              <img
                src={NESTED_ITEM_IMAGES[nestedItem.path as keyof typeof NESTED_ITEM_IMAGES]}
                alt="navigation item"
              />
            ) : (
              (() => {
                const IconComponent =
                  NESTED_ITEM_IMAGES[nestedItem.path as keyof typeof NESTED_ITEM_IMAGES];
                return <IconComponent size={24} />;
              })()
            )}
          </div>
        ) : (
          <div className="ImageContainer">
            <div className="PlaceholderImage">
              <div className="Text">
                {nestedItem &&
                  nestedItem.displayName &&
                  typeof nestedItem.displayName == "string" &&
                  nestedItem.displayName.length > 0 &&
                  nestedItem.displayName.charAt(0)}
              </div>
            </div>
          </div>
        )}

        {active && <div className="ActiveMarker" data-testid="nav-active-marker"></div>}

        {hasNestedElements && (
          <img
            src={dropdownArrow}
            alt="dropdown"
            className={`DropdownIcon ${showNestedElements ? "Open" : ""}`}
          />
        )}

        {hasNestedElements ? (
          <div className="NestedItemText">{nestedItem.displayName}</div>
        ) : !nestedItem.path ? (
          <div className="Text">{nestedItem.displayName}</div>
        ) : isExternalLink ? (
          <a href={nestedItem.path} target="_blank" rel="noreferrer">
            <div className="Text">{nestedItem.displayName}</div>
          </a>
        ) : (
          <Link to={nestedItem.path} onClick={closeMobileNav}>
            <div className="Text">{nestedItem.displayName}</div>
          </Link>
        )}
      </li>

      {showNestedElements && hasNestedElements && (
        <NestedElements
          accessElement={nestedItem}
          pathName={pathName}
          closeMobileNav={closeMobileNav}
          showNestedElements={showNestedElements}
        />
      )}
    </div>
  );
};
